import { createReducer, on } from '@ngrx/store';
import { 
    fetchSingleRecordSuccess,
    resetState
} from './service-fee.action';
import { ServiceFee } from './service-fee.model';

export interface ServiceFeeRecordsState {
    listData: ServiceFee[];
    singleData: ServiceFee;
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: ServiceFeeRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0
};


export const ServiceFeeRecordReducer = createReducer(

    initialState,
    
    // FETCH SINGLE
    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, loading: false, error: null };
    }),

    //RESET STATE
    on(resetState, () => initialState)  // Reset action handler
    
);